// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".margin-select[data-v-1bbfbe14]{margin-left:15px;margin-top:20px}", "",{"version":3,"sources":["webpack://./resources/assets/js/components/api/ServicosApi.vue"],"names":[],"mappings":"AACA,gCACE,gBAAY,CACZ,eAAF","sourcesContent":["\n.margin-select\n  margin-left 15px\n  margin-top 20px\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
